import styled from 'styled-components';

import media from '../../styles/media.style';
import { BG_GRAY, TEXT_GRAY, BLACK, SCREEN_LOCKUP_WIDTH, MOBILE_PADDING } from '../../styles/variables.style';

export const Section = styled.section`
  color: ${TEXT_GRAY.COMMON_5};
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  max-width: ${SCREEN_LOCKUP_WIDTH + MOBILE_PADDING * 2}px;
  padding: 20px ${MOBILE_PADDING}px;
  width: 100%;

  ${media.tabletL`
    align-items: center;
    padding: 40px 0;
  `};
`;

export const Title = styled.h5`
  position: relative;
  font-size: 16px;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  margin: 0 0 60px;
  text-align: center;

  &::after {
    content: '';
    position: absolute;
    bottom: -18px;
    left: 50%;
    transform: translateX(-50%);
    background-color: ${BG_GRAY.COMMON_8};
    height: 3px;
    width: 40px;
  }

  ${media.tabletL`
    margin-bottom: 175px;
  `};
`;

export const KeyIngredientsContainer = styled.div`
  margin: auto;
  max-width: 500px;
  width: 100%;

  ${media.tabletL`
    align-items: center;
    display: flex;
    max-width: unset;
  `};
`;

export const KeyIngredientsImages = styled.div`
  order: -1;
  margin-bottom: 3em;
  padding-bottom: 100%;
  position: relative;
  width: 100%;

  ${media.tabletL`
    order: 0;
    padding-bottom: 50%;
    margin-bottom: 0;
    width: 50%;
  `};

  &::before {
    background-color: #71953f;
    content: '';
    left: 0%;
    padding-bottom: 10%;
    position: absolute;
    top: 30%;
    width: 10%;
  }

  &::after {
    background-color: #f5d35b;
    content: '';
    left: 90%;
    padding-bottom: 10%;
    position: absolute;
    top: 60%;
    width: 10%;
  }
`;

export const Pseudo = styled.div`
  background-color: #f2f2f2;
  left: 50%;
  padding-bottom: 10%;
  position: absolute;
  top: 80%;
  width: 10%;
  z-index: -1;
`;

export const KeyIngredientsImage = styled.div`
  height: 40%;
  left: ${({ left }) => left};
  position: absolute;
  top: ${({ top }) => top};
  transform: translate(-50%, -50%);
  width: 40%;
`;

export const KeyIngredientsText = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  width: 100%;

  ${media.tabletL`
    padding-left: 100px;
    width: 50%;
  `};
`;

export const OtherIngredientsContainer = styled.div`
  display: block;
  height: auto;
  max-height: ${({ visible }) => (visible ? '400px' : '0')};
  transition: max-height 0.5s ease-in-out;
  overflow: hidden;
`;

export const SubTitle = styled.h5`
  font-size: 16px;
  margin: 2em 0 1em;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  text-align: center;
`;

export const Text = styled.p`
  font-size: 16px;
  line-height: 1.5em;
  margin: 0;
`;

export const ShowMore = styled.button`
  font-size: 14px;
  position: relative;
  cursor: pointer;
  margin: 4em 0 0;
  background-color: transparent;
  border: 0;
  border-radius: 0;
  padding: 0;
  color: ${BLACK};
  text-transform: uppercase;
  text-align: center;
`;

export const Chevron = styled.span`
  border-style: solid;
  border-width: 0.15em 0.15em 0 0;
  content: '';
  display: inline-block;
  height: 0.7em;
  transform: ${({ visible }) => (visible ? 'rotate(-45deg)' : 'rotate(135deg)')};
  vertical-align: top;
  width: 0.7em;
  margin-left: 0.7em;
  margin-top: ${({ visible }) => (visible ? '5px' : '0px')};
`;



// WEBPACK FOOTER //
// ./src/components/ProductIngredients/ProductIngredients.style.js